import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "survey-say" }
const _hoisted_2 = { class: "survey-say--avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "dot dot-1" }
const _hoisted_5 = { class: "dot dot-2" }
const _hoisted_6 = { class: "dot dot-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]

import { computed, onMounted, ref } from 'vue'
import { Options, SurveyParams } from '@/entities/conversation'
import ConversationItemReselectScore from './ConversationItemReselectScore.vue'
import snarkdown from 'snarkdown'

interface Props {
    message: string
    surveyParams: SurveyParams
    avatarSrc?: string
    isActive: boolean
    isFollowedByInput?: boolean
    csatLabels: Options
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationItemSay',
  props: {
    message: {},
    surveyParams: {},
    avatarSrc: {},
    isActive: { type: Boolean },
    isFollowedByInput: { type: Boolean },
    csatLabels: {}
  },
  emits: ['callNext', 'updateScore'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "5544137b": (backgroundColor.value),
  "8de98148": (textColor.value)
}))

const props = __props
const emit = __emit

const isLoading = ref(true)
const hasReselectScore = ref(false)
const messageBeforeReselect = ref('')
const messageAfterReselect = ref('')

const backgroundColor = computed(() =>
    props.isActive || props.isFollowedByInput ? 'var(--brandColor)' : '#fff'
)
const textColor = computed(() =>
    props.isActive || props.isFollowedByInput ? '#fff' : 'var(--brandColor)'
)

const formattedMessage = computed(() =>
    snarkdown(props.message.replace(/\n/gi, '<br/>').trim())
)

const formattedMessageBeforeReselect = computed(() =>
    snarkdown(messageBeforeReselect.value.replace(/\n/gi, '<br/>').trim())
)

const formattedMessageAfterReselect = computed(() =>
    snarkdown(messageAfterReselect.value.replace(/\n/gi, '<br/>').trim())
)

onMounted(() => {
    if (props.isActive) {
        setTimeout(() => {
            isLoading.value = false
            emit('callNext')
        }, 1000)
    } else {
        isLoading.value = false
    }

    if (props.message.includes('{answer}')) {
        hasReselectScore.value = true
        messageBeforeReselect.value = props.message.split('{answer}')[0]
        messageAfterReselect.value = props.message.split('{answer}')[1]
    }
})

const handleUpdateScore = (data) => {
    emit('updateScore', data)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.avatarSrc && (_ctx.isActive || _ctx.isFollowedByInput))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.avatarSrc,
            alt: "Avatar"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["survey-say--bubble", { active: _ctx.isActive }])
    }, [
      _withDirectives(_createElementVNode("span", _hoisted_4, null, 512), [
        [_vShow, isLoading.value]
      ]),
      _withDirectives(_createElementVNode("span", _hoisted_5, null, 512), [
        [_vShow, isLoading.value]
      ]),
      _withDirectives(_createElementVNode("span", _hoisted_6, null, 512), [
        [_vShow, isLoading.value]
      ]),
      _withDirectives(_createElementVNode("span", { innerHTML: formattedMessage.value }, null, 8, _hoisted_7), [
        [_vShow, !isLoading.value && !hasReselectScore.value]
      ]),
      _withDirectives(_createElementVNode("span", null, [
        _createElementVNode("span", { innerHTML: formattedMessageBeforeReselect.value }, null, 8, _hoisted_8),
        _createVNode(ConversationItemReselectScore, {
          score: props.surveyParams.answer || 0,
          "question-type": _ctx.surveyParams.questionType,
          interact: true,
          "csat-labels": props.csatLabels,
          onUpdatescore: handleUpdateScore
        }, null, 8, ["score", "question-type", "csat-labels"]),
        _createElementVNode("span", { innerHTML: formattedMessageAfterReselect.value }, null, 8, _hoisted_9)
      ], 512), [
        [_vShow, !isLoading.value && hasReselectScore.value]
      ])
    ], 2)
  ]))
}
}

})